import {Injectable} from '@angular/core';
import {ApiListDataService} from './api.list-data.service';
import {HttpClient} from '@angular/common/http';
import {DistrTaskByProjectModel} from '../../models';

@Injectable({
  providedIn: 'root'
})
export class ApiDistrTaskByProjectService extends ApiListDataService<DistrTaskByProjectModel, DistrTaskByProjectModel> {

  constructor(http: HttpClient) {
    super(http, '/Task/DistrTaskByProject/');
  }
}
